// src/hooks/useAnalytics.js
import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.initialize('G-83QVRB141R');
  }, []);

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: location.pathname });
  }, [location]);

  // Helper for custom events
  const trackEvent = (action, params = {}) => {
    ReactGA.event(action, params);
  };

  return { trackEvent };
};
